export const formatBirthdayWithGender = (birthdayStr: string, sex: string) => {
  if (!birthdayStr) return "";

  const birthDate = new Date(birthdayStr);
  const year = birthDate.getFullYear();

  const shortYear = year % 100;

  const month = String(birthDate.getMonth() + 1).padStart(2, "0");
  const day = String(birthDate.getDate()).padStart(2, "0");

  let genderCode;
  if (year >= 2000) {
    genderCode = sex === "male" ? "3" : "4";
  } else {
    genderCode = sex === "male" ? "1" : "2";
  }

  return `${shortYear}${month}${day}${genderCode}`;
};
